import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../redux/hooks/hooks";
import { navigateBack } from "../../../redux/feature/general/navigation-slice";
import { SOURCES } from "../../../utils/constants/navigation";
import { DocumentPartTreeSelection, TreeViewDataItem } from "../../cpm/DocumentPartTree";
import { DocumentPart } from "../../../api/models";
import { fetchExpandedDocumentPartOutline } from "../../../api/document/DocumentsPart";

export interface useDocumentSourcePanelProps {
  idPartRoot: string;
}

export const useDocumentSourcePanel = (props: useDocumentSourcePanelProps) => {
  const defaultHeaderName = formatMessage("cof.documentsources.viewall.subtitle");
  const [headerName, setHeaderName] = useState(defaultHeaderName);
  const [isViewList, setIsViewList] = useState(false);
  const [documentSourceTree, setDocumentSourceTree] = useState<TreeViewDataItem[]>();
  const [selectedSource, setSelectedSource] = useState<DocumentPartTreeSelection>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    loadDocumentSourceTree();
  }, []);

  const loadDocumentSourceTree = () => {
    fetchExpandedDocumentPartOutline(props.idPartRoot).then((result) =>
      setDocumentSourceTree([mapDocPartToDataItem(result)])
    );
  };

  const goBack = () => {
    if (!isViewList) dispatch(navigateBack(SOURCES));
    else setIsViewList(false);
  };

  const loadViewList = (headerName: string) => {
    setHeaderName(headerName);
    setIsViewList(true);
    setSelectedSource(null);
  };

  const onItemSingleClick = (documentPartTreeSelection: DocumentPartTreeSelection) => {
    if (documentPartTreeSelection.item.hasReadPermissions) {
      if (documentPartTreeSelection.item.text) loadViewList(documentPartTreeSelection.item.text);
      else loadViewList(defaultHeaderName);
      setSelectedSource(documentPartTreeSelection);
    }
  };

  const mapDocPartToDataItem = (documentPart: DocumentPart): TreeViewDataItem => {
    return {
      key: documentPart.id,
      text: documentPart.name,
      order: documentPart.order,
      nodeType: documentPart.root ? "root" : "part",
      hasChildren: documentPart.hasChildren,
      expanded: documentPart.subparts?.length > 0,
      checked: false,
      selected: false,
      items: documentPart.subparts?.map(mapDocPartToDataItem),
      data: documentPart,
    };
  };

  return {
    isViewList,
    headerName,
    documentSourceTree,
    selectedSource,
    goBack,
    loadViewList,
    onItemSingleClick,
  };
};
